var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Preview = function Preview(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 12 12' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Combined Shape'
      ),
      React.createElement('path', { d: 'M8 0v1h2.293L5.646 5.647l.708.708L11 1.707V4h1V0H8zm3 10.2a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8V1.8a.8.8 0 0 1 .8-.8H6V0H1.8C.807 0 0 .807 0 1.8v8.4c0 .992.807 1.8 1.8 1.8h8.4c.993 0 1.8-.808 1.8-1.8V6h-1v4.2z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Preview;
//# sourceMappingURL=Preview.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Preview.js